import React from "react";
import AlertBanner from "decodable-ui/lib/components/AlertBanner";
import Link from "decodable-ui/lib/components/Link";
import { ActiveAccountContextValue } from "../accounts/hooks/useAccounts";

export function DataPlaneSetupAlert(props: {
  activeAccountCtx: ActiveAccountContextValue;
}) {
  if (
    !props.activeAccountCtx.activeAccount ||
    props.activeAccountCtx?.accountInfo?.deployment_type != "byoc" ||
    (props.activeAccountCtx?.accountInfo?.data_plane_hostname &&
      props.activeAccountCtx?.accountInfo?.data_plane?.m_tlssigning_state ==
        "AVAILABLE")
  ) {
    // If the account info is still loading, the current account is not BYOC,
    // or the data plane URL and mTLS are already configured, render null.
    return null;
  }

  // If mTLS isn't configured yet, pop up a banner for that
  if (
    props.activeAccountCtx?.accountInfo?.data_plane?.m_tlssigning_state !=
    "AVAILABLE"
  ) {
    return (
      <AlertBanner severity="info" sx={{ margin: 0, padding: 0 }}>
        Action required:{" "}
        <Link
          sx={{
            color: "white",
            textDecoration: "underline",
            display: "inline",
          }}
          href={`/${props.activeAccountCtx.activeAccount.name}/account?tab=data-plane`}
        >
          Configure your mTLS credentials
        </Link>{" "}
        to complete account setup.
      </AlertBanner>
    );
  }

  // If mTLS is configured but the data plane host isn't, pop up a banner for thate
  return (
    <AlertBanner severity="info" sx={{ margin: 0, padding: 0 }}>
      Action required:{" "}
      <Link
        sx={{
          color: "white",
          textDecoration: "underline",
          display: "inline",
        }}
        href={`/${props.activeAccountCtx.activeAccount.name}/account?tab=data-plane`}
      >
        Configure the data plane host
      </Link>{" "}
      to complete account setup.
    </AlertBanner>
  );
}
